module.exports = __webpack_public_path__ + "img/product_114.fb733f0.svg";